import { ReserveInfo, setState } from '@/commonTypes';
import styles from './styles.module.css';
import { useEffect, useState } from 'react';

export default function TimeSlots({
  onChange,
  info,
  setInfo,
  timeSlots,
  className = '',
}: {
  onChange: (value: any, key: string) => void;
  info?: ReserveInfo;
  setInfo: setState<ReserveInfo>;
  timeSlots?: { id?: number; time?: string; state?: string }[];
  className?: string;
}) {
  const [error, setError] = useState(false);
  console.log('error==========', error);
  useEffect(() => {
    setError(false);
  }, [info?.date]);
  return (
    <>
      <div className={`${styles.container} ${className}`}>
        {timeSlots?.map((x, index) => (
          <button
            key={index}
            disabled={x?.state != 'available'}
            className={`${styles.button} ${x?.state == 'available' && styles.available} ${Number(info?.time) == x?.id && 'btn btn-primary'} ${x?.state == 'disabled' && styles.disabled} `}
            onClick={() => {
              if (info?.date?.length != 0) {
                onChange(x?.id, 'time');
                setError(false);
              } else {
                setError(true);
              }
            }}
          >
            {x?.time}
          </button>
        ))}
      </div>
      {((info?.error?.time && info?.messages?.time) || error) && (
        <p className={`inputErrorText`}>{error ? 'روز را انتخاب کنید.' : info?.messages?.time}</p>
      )}
    </>
  );
}
